import React from "react";

import styled, { css } from "styled-components";

const Size = css`
    ${(props) =>
        props.size === "xsmall" &&
        css`
            font-size: 1rem;
            font-weight: 400;
        `}
    ${(props) =>
        props.size === "small" &&
        css`
            font-size: 1.2rem;
            font-weight: 400;
        `}

    ${(props) =>
        props.size === "regular" &&
        css`
            font-size: 1.4rem;
            font-weight: 400;
        `}
`;

const Text = styled.div`
    margin: ${(props) => props.textMargin || "0"};
    line-height: 1.4;
    text-align: ${(props) => props.textAlign || "left"};
    font-weight: ${(props) => props.fontWeight || "600"};
    color: ${(props) => props.fontColor || "var(--color-White)"};
    transition: all 80ms ease-in;

    ${Size}

    ${(props) =>
        props.hoverTextStyle &&
        `
        &:hover { ${props.hoverTextStyle} };
    `}
`;

const Container = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
    width: ${(props) => props.width || "100%"};
    min-width: ${(props) => props.minWidth};
    height: ${(props) => props.height || "40px"};
    border: ${(props) => props.border || "transparent"};
    border-radius: ${(props) => props.borderRadius || "4px"};
    background-color: ${(props) => props.bgColor || "var(--color-Button1)"};
    transition: all 120ms ease-in;

    ${(props) =>
        props.onlyIcon &&
        css`
            min-width: ${(props) => props.width};
        `}

    &:hover {
        background-color: ${(props) => props.hoverBgColor || "var(--color-Key)"};
    }

    // 클릭 효과 (살짝 작게 눌리는 느낌)
    &:active:not(:disabled) {
        transform: scale(0.97);
        transition-duration: 80ms;
    }

    &:disabled {
        background-color: ${(props) =>
            props.transparentDisabled ? props.bgColor || "transparent" : "var(--color-DisabledButton)"};
        cursor: not-allowed;
    }

    &:disabled:hover {
        background-color: ${(props) =>
            props.transparentDisabled ? props.bgColor || "transparent" : "var(--color-DisabledButton)"};
    }
`;

const ButtonIconWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${(props) => props.iconMargin || "0"};
    width: ${(props) => props.iconSize || "16px"};
    height: ${(props) => props.iconSize || "16px"};
`;

const Button = React.forwardRef(function Button(props, ref) {
    const {
        onClick,
        onMouseDown,
        margin,
        padding,
        width,
        height,
        border,
        borderRadius,
        bgColor,
        hoverBgColor,
        disabled,
        type,
        className,
        fontSize,
        iconSize,
        onlyIcon,
        onlyText,
        transparentDisabled,
        minWidth,
        textMargin,
        fontWeight,
        textAlign,
        fontColor,
        hoverTextStyle,
        buttonSize,
        style,
        buttonText,
        children,
        ...restProps
    } = props;

    const commonProps = {
        onClick,
        onMouseDown,
        margin,
        padding,
        width,
        height,
        border,
        borderRadius,
        bgColor,
        hoverBgColor,
        disabled,
        type: type || "button",
        className: className || "",
        size: fontSize,
        iconSize,
        onlyIcon,
        transparentDisabled,
        minWidth,
        ...restProps,
    };

    const textProps = {
        textMargin,
        size: fontSize || "regular",
        fontWeight,
        textAlign,
        fontColor: disabled && !transparentDisabled ? "var(--color-White)" : fontColor,
        hoverTextStyle,
    };

    if (onlyIcon) {
        return (
            <Container
                {...commonProps}
                ref={ref}
                width={buttonSize || "24px"}
                height={buttonSize || "24px"}
                bgColor={bgColor || "var(--color-Button1)"}
                hoverBgColor={hoverBgColor || "var(--color-ButtonHover1)"}
                style={{ ...style }}
            >
                <ButtonIconWrap iconMargin={"0"} iconSize={iconSize}>
                    {children}
                </ButtonIconWrap>
            </Container>
        );
    }

    if (onlyText) {
        return (
            <Container {...commonProps} ref={ref} style={{ ...style }}>
                <Text {...textProps}>{buttonText}</Text>
            </Container>
        );
    }

    return (
        <Container {...commonProps} ref={ref} style={{ ...style }}>
            <ButtonIconWrap iconSize={iconSize}>{children}</ButtonIconWrap>
            <Text {...textProps}>{buttonText}</Text>
        </Container>
    );
});

export default Button;
